<template>
  <span class="p-small-text" :style="textStyle">
    <slot />
  </span>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
    props:{
        weight: { type: String, default: "normal" },
        size: { type: Number, default: 12 },
        color: { type: String, default: "" }
    }
})
export default class SmallText extends Vue {
  weight!: string;
  size!: number;
  color!: string;

  get textStyle() {
    return {
      color: this.color,
      fontSize: `${this.size / 16}rem`,
      fontWeight: this.weight
    };
  }
}
</script>

<style lang="scss" scoped>
.p-small-text {
  font-size: $text-size__body--s;
  color: $common-gray500;
  display: block;
  line-height: 1.6;
}
</style>
